import React, { FC, useEffect, useState, useContext } from "react";
import {
  AEAStepper,
  AEAStep,
  BasicDataProa,
  DetailDataProa,
  DetailDataImplementProa,
  ProaDetailDataLocations,
  BaseDataProaRRHH,
  ProjectIndicators,
  BaseDataConfig
} from "@/components/";
import { ValidationGroup } from "devextreme-react/validation-group";
import { Button, Form } from "reactstrap";
import { Dictionary, Utilities } from "@utils";
import storeContext from "@/context/store-context";
import styles from "./proa-summary.module.scss";
import { ProaSummaryPresenter } from "@presenters/screens/proa-summary.presenter";
import {
  IAEAColumnDefinition,
  IQueryProa,
  ProaTablaInSections,
} from "@models/*";

const { StoreContext } = storeContext;

const ProaSummary: FC<any> = (props: {
  basicDataColumnDefinition: Dictionary<string, IAEAColumnDefinition>;
  currentApplicationMasters: any;
  projectsGrouped: any;
}) => {

  const [swichForm, setSwichForm] = useState(null);
  const [currentProaFormValues, setCurrentProaFormValues] = useState<IQueryProa>();
  const [section4Locations, setSection4Locations] = useState<ProaTablaInSections>();
  const [basicdataFFRR, setBasicdataFFRR] = useState();
  const [proaSubproyect, setProaSubproyect] = useState([]);
  const [beneficiariesDuplicates, setBeneficiariesDuplicates] = useState();
  const [basicdataSPC, setBasicdataSPC] = useState();
  const [localPertners, setLocalPertners] = useState();
  const [beginDate, setBeginDate] = useState();
  const [endDate, setEndDate] = useState();

  const context = useContext(StoreContext);

  let validationGroup: ValidationGroup;
  const presenter = new ProaSummaryPresenter({
    state: {
      currentProaFormValues,
      setCurrentProaFormValues,
      currentApplicationMasters: props.currentApplicationMasters,
      basicDataColumnDefinition: props.basicDataColumnDefinition,
      section4Locations,
      setSection4Locations,
      basicdataFFRR,
      setBasicdataFFRR,
      proaSubproyect,
      setProaSubproyect,
      beneficiariesDuplicates,
      setBeneficiariesDuplicates,
      basicdataSPC,
      setBasicdataSPC,
      localPertners,
      setLocalPertners,
      beginDate,
      setBeginDate,
      endDate,
      setEndDate,
    },
  });

  useEffect(() => {
    if (!Utilities.isNullObject(props.basicDataColumnDefinition) && !Utilities.isNullObject(props.currentApplicationMasters)) {
      presenter.onInitialize();
    }
  }, [props.basicDataColumnDefinition, props.currentApplicationMasters]);

  let hasPermission = presenter.getTotalPermissions()

  return presenter.initRender() ? (
    <Form>
      <ValidationGroup ref={(ref) => (validationGroup = ref)}>
        <AEAStepper
          activateValidation={Utilities.isNullObject(swichForm) ? false : true}
          activeAll={false}
          errorSelectors={[".dx-invalid"]}
          defaultStep={presenter.currentLabels.get("ProaFormDatosBasicos")}
        >
          <AEAStep title={presenter.currentLabels.get("ProaFormDatosBasicos")}>
            <BasicDataProa presenter={presenter}></BasicDataProa>
          </AEAStep>
          <AEAStep
            title={presenter.currentLabels.get("ProaFormQueComoQuienDonde")}
          >
            <DetailDataProa presenter={presenter}></DetailDataProa>
          </AEAStep>
          <AEAStep
            title={presenter.currentLabels.get(
              "ProaFormQueComoQuienDondeImplementers"
            )}
          >
            <DetailDataImplementProa
              presenter={presenter}
            ></DetailDataImplementProa>
          </AEAStep>
          <AEAStep
            title={presenter.currentLabels.get(
              "ProaFormQueComoQuienDondeLocalizaciones"
            )}
          >
            <ProaDetailDataLocations
              presenter={presenter}
            ></ProaDetailDataLocations>
          </AEAStep>
          <AEAStep
            title={presenter.currentLabels.get(
              "ProaFormQueComoQuienDondeOtrosIndicadores"
            )}
          >
            <ProjectIndicators presenter={presenter} ></ProjectIndicators>
          </AEAStep>
          <AEAStep title={presenter.currentLabels.get("ProaFormDatosRRHH")}>
            <BaseDataProaRRHH presenter={presenter}></BaseDataProaRRHH>
          </AEAStep>
          <AEAStep title={presenter.currentLabels.get("ConfigStep")}>
            <BaseDataConfig summaryPresenter={presenter} projectsGrouped={props.projectsGrouped}></BaseDataConfig>
          </AEAStep>
        </AEAStepper>
        <div className={styles["form-buttons"]}>
          {(presenter.isViewMode && !hasPermission) ? null : (
            <Button
              className={styles["save-button"]}
              onClick={(e) => {
                e.preventDefault();
                if (validationGroup.instance.validate().isValid) {
                  presenter.save();
                } else {
                  Utilities.notifyError(
                    presenter.currentLabels.get("Datos invalidos")
                  );
                }
                setSwichForm(!swichForm);
              }}
            >
              {presenter.currentLabels.get("Guardar")}
            </Button>
          )}

          <Button
            onClick={(e) => {
              context.history.push("/proyecta/proa");
            }}
          >
            {presenter.currentLabels.get("Cancelar")}
          </Button>
        </div>
      </ValidationGroup>
    </Form>
  ) : (
    <div></div>
  );
};

export default ProaSummary;
